import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductLowStock extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  #handleVariantUpdate = (event) => {
    const { resource, data } = event.detail;

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    // No variant selected yet (size picker awaiting a choice): keep the message hidden.
    if (!resource) {
      this.hidden = true;
      this.replaceChildren();
      return;
    }

    const newElement = data.html.querySelector(
      `product-low-stock[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newElement) return;

    // A size is now selected — reveal and sync the message for the chosen variant.
    this.hidden = false;
    morph(this, newElement, { childrenOnly: true });
  };
}

if (!customElements.get('product-low-stock')) {
  customElements.define('product-low-stock', ProductLowStock);
}
